import { Center, Loader } from "@mantine/core";
import { useGetApi } from "src/hooks";

import CustomDashboard from "../../components/pages/Home/CustomDashboard/CustomDashboard";
import { Navigate, useParams } from "react-router-dom";

const CustomDashboardPage = () => {
  const { lbid } = useParams();
  const { data: resp, isLoading } = useGetApi<{
    data: {
      yachtid: string;
      logbooks: { customDashboard?: any };
    };
  }>({
    request: "get-home",
  });

  if (isLoading || !resp) {
    return (
      <Center style={{ height: "100%" }}>
        <Loader />
      </Center>
    );
  }

  const customDashboard = resp?.data?.logbooks?.customDashboard;
  const yachtid = resp?.data?.yachtid;

  if (!customDashboard) {
    return <Navigate to={`/collection/${lbid}`} replace />;
  }

  return (
    <CustomDashboard customDashboard={customDashboard} yachtid={yachtid} />
  );
};

export default CustomDashboardPage;
